// Constants for different requests for current reducer
export default {
  createVisit: 'CREATE_VISITOR_LOG_VISIT',
  visitorLogSites: 'VISITOR_LOG_SITES',
  visitorLogVisitors: 'VISITOR_LOG_VISITORS',
  visitorLogEvents: 'VISITOR_LOG_EVENTS',
  visitorLogEvent: 'VISITOR_LOG_EVENT',
  visitorLogVisits: 'VISITOR_LOG_VISITS',
  visitorLogVisit: 'VISITOR_LOG_VISIT',
};
